import React from "react";

const BackIcon = ({ width, height, fill }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        d="M3.825 9L9.425 14.6L8 16L0 8L8 0L9.425 1.4L3.825 7H16V9H3.825Z"
        fill={fill}
      />
    </svg>
  );
};

BackIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: "black",
};

export default BackIcon;
